import memoize from 'memoize';
import axios from 'axios';

const clearAuthTokens = () => {
  localStorage.removeItem('uuidLocal');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
};

const refreshTokenFn = async () => {
  const uuid_local = localStorage.getItem('uuidLocal');
  const refreshToken = localStorage.getItem('refreshToken');

  if (!uuid_local || !refreshToken) {
    clearAuthTokens();
    return null;
  }

  try {
    const response = await axios.patch(
      `/api/v1/jwt/${uuid_local}`,
      {
        data: {
          id: uuid_local,
          type: 'jwt',
          attributes: {
            refreshToken: refreshToken,
          },
        },
      },
      {
        headers: {
          'Content-Type': 'application/vnd.api+json',
        },
      }
    );

    const accessToken = response?.data?.data?.attributes?.accessToken;
    const nextRefreshToken = response?.data?.data?.attributes?.refreshToken;
    const nextUuid = response?.data?.data?.id;

    if (!accessToken || !nextRefreshToken || !nextUuid) {
      clearAuthTokens();
      return null;
    }

    localStorage.setItem('uuidLocal', nextUuid);
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', nextRefreshToken);
    return { accessToken };
  } catch (error) {
    clearAuthTokens();
    return null;
  }
};

const maxAge = 10000;

export const memoizedRefreshToken = memoize(refreshTokenFn, {
  maxAge,
});
